export enum DocumentDirectionCodes {
     ARRIVAL = 'A',
     DEPARTURE = 'D',
     OTHER = 'O'
}